import { forwardRef, useEffect, useState, useRef, Fragment } from 'react';

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';

import useDebounce from 'hook/useDebounce';
// import getAddress from 'api/getAddress';
import { getThailandAddress } from 'api/getThailandAddress';

const AutoCompleteDistrict = forwardRef(({ value, onChange, onCommit, error }, ref) => {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);

  const [inputValue, setInputValue] = useState(value);
  const debounceValue = useDebounce(inputValue, 500);
  const loading = useRef(false);

  useEffect(() => {
    let active = true;

    if (debounceValue) {
      loading.current = true;

      const regex = /(^ตำบล|^แขวง|^เขต|^อำเภอ)/i;
      const keyword = debounceValue.replace(regex, '');
      const results = getThailandAddress(keyword);
      console.log(results);
      if (results.length) {
        setOptions([...results]);
      }
      loading.current = false;

      // (async () => {
      //   const regex = /(^ตำบล|^แขวง|^เขต|^อำเภอ)/i;
      //   const keyword = debounceValue.replace(regex, '');
      //   getAddress(keyword)
      //     .then((data) => {
      //       loading.current = false;
      //       // console.log(res.data);
      //       if (active && data.length) {
      //         setOptions([...data]);
      //       }
      //     })
      //     .catch(console.error);
      // })();
    }

    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debounceValue]);

  useEffect(() => {
    if (value === '') {
      setOptions([]);
      setInputValue('');
    }
  }, [value]);

  const onOpen = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  return (
    <Autocomplete
      // value={selValue}
      onChange={(_, value) => {
        if (value?.zipcode) {
          const curr = options.find((x) => x.zipcode === value.zipcode);
          // console.log(curr);
          onCommit(curr);
        }
      }}
      // onChange={(_, value) => {
      //   if (value?._id) {
      //     const curr = options.find((x) => x._id === value._id);
      //     // console.log(curr);
      //     onCommit(curr);
      //   }
      // }}
      freeSolo
      inputValue={inputValue}
      onInputChange={(_, value) => {
        setInputValue(value);
        onChange(value);
      }}
      open={open}
      onOpen={onOpen}
      onClose={onClose}
      isOptionEqualToValue={(option, value) => option._id === value._id}
      getOptionLabel={(option) => option.district}
      options={options}
      loading={loading.current}
      renderOption={(props, option) => {
        return (
          <li {...props} key={option._id}>
            {`${option.district} - (${option.province})`}
          </li>
        );
      }}
      renderInput={(params) => (
        <TextField
          ref={ref}
          placeholder={'ตำบล/แขวง'}
          size="large"
          {...params}
          error={error}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <Fragment>
                {loading.current ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </Fragment>
            ),
          }}
        />
      )}
    />
  );
});

export default AutoCompleteDistrict;
